<div class="container">
  @if (linqsetEdge && source && target) {
    <h3>Connection</h3>

    <div class="ends">
      <div class="end">
        <app-node-svg [type]="source.type"/>
        <span class="end-name">{{source.name}}</span>
        <span class="end-kind">{{source.kind}}</span>
      </div>
      <div class="relationship">
        <mat-icon aria-hidden="true">arrow_forward</mat-icon>
        <span>{{getEdgeTypeDescription()}}</span>
      </div>
      <div class="end">
        <app-node-svg [type]="target.type"/>
        <span class="end-name">{{target.name}}</span>
        <span class="end-kind">{{target.kind}}</span>
      </div>
    </div>

    @if (isJoin()) {
      <div class="join">
        @if (canSwitch) {
          <mat-slide-toggle (change)="toggleType()" [checked]="linqsetEdge.type===EDGE_TYPE.JOINS">Use items processed as an input</mat-slide-toggle>
        }
        <p class="note">
          @if (linqsetEdge.type===EDGE_TYPE.JOINS) {
            Items processed by {{source.name}} are used as an input to {{target.name}}.
          }@else {
            Items processed by {{source.name}} are not used as an input to {{target.name}}.
          }
        </p>
        @if (switchMessage) {
          <p class="note warning">{{switchMessage}}</p>
        }
      </div>
    }

    @if (edge.tag.nodes && edge.tag.nodes.length > 0) {
      <h3>Connection includes</h3>
      <ul class="contains">
        @for (n of edge.tag.nodes; track n._key || n) {
          <li><app-node-svg [type]="n.type"/><span>{{n.name}}</span></li>
        }
      </ul>
    }
  }@else {
    <p class="note">There are no details for this connection.</p>
  }
</div>
